export interface AgentAccessGrant {
  id: number;
  agent_id: string;
  max_uses: number;
  use_count: number;
  expires_at: string | null;
  last_used_at: string | null;
  granted_by: string | null;
  created_at: string;
  label?: string;
  token?: string;
}

export interface AgentAccessGrantWithToken extends AgentAccessGrant {
  token: string;
}

export interface AgentUserProfile {
  id: string;
  full_name: string | null;
  email: string | null;
  avatar_url: string | null;
}

export interface AgentUser {
  agent_id: string;
  user_id: string;
  granted_by: string | null;
  expires_at: string | null;
  created_at: string;
  profile?: AgentUserProfile;
}

export interface CreateGrantData {
  max_uses?: number;
  expires_at?: string;
}

export interface UpdateGrantData {
  max_uses?: number;
  expires_at?: string | null;
}

export interface AgentAccessPerson {
  id: string;
  email: string | null;
  full_name: string | null;
  role: string | null;
  team_id: number | null;
}

export interface AgentAccessDiagnosis {
  agent: { id: string; name: string | null; user_id: string } | null;
  owner: AgentAccessPerson | null;
  team: { id: number; name: string | null; owner_id: string | null } | null;
  members: AgentAccessPerson[];
  grants: Array<{
    user_id: string;
    granted_by: string | null;
    expires_at: string | null;
    created_at: string;
    user: AgentAccessPerson | null;
  }>;
  caller: (AgentAccessPerson & { team: { id: number; name: string | null; owner_id: string | null } | null }) | null;
  rule: "admin" | "owner" | "team-owner" | "teammate" | null;
  reason: string;
}

export const ACCESS_PASSWORD_GRANT_DAYS = [90, 180, 365] as const;
export const ACCESS_PASSWORD_MIN_LENGTH = 6;

export type AccessPasswordGrantDays = (typeof ACCESS_PASSWORD_GRANT_DAYS)[number];

export interface AgentAccessPassword {
  enabled: boolean;
  grant_days: AccessPasswordGrantDays | null;
  updated_at: string | null;
  active_unlocks: number;
}

export interface SetAccessPasswordData {
  password?: string;
  grant_days: AccessPasswordGrantDays;
}
